export default __webpack_public_path__ + "static/media/koreadaily.b4a6f457.png";